import React from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import { LabeledObject } from 'types';
import { arrayToString } from 'utils/array-to-string';

function getLabel(enums: LabeledObject[], data: string) {
  const value = enums.find(({ id }) => id === data);
  const index = value?.index ? `${value.index}. ` : '';

  const label = `${index}${value?.label ?? ''}`;

  return label;
}

/**
 * Table cell factory method for enum value with custom fetch hook.
 */
export function tableCellEnumFactory(
  enumHook: () => LabeledObject[],
  isArray: boolean = false
) {
  return function TableCellEnum({ data }: { data: any }) {
    const enums = enumHook();

    let label = '';
    if (isArray) {
      label = arrayToString(data as string[], (value) =>
        getLabel(enums, value)
      );
    } else {
      label = getLabel(enums, data as string);
    }

    return (
      <Typography title={label} component="div" variant="body2">
        {label}
      </Typography>
    );
  };
}
